import React, { useContext } from 'react';
import api from '../../services/api';
import { Context } from '../../services/contexts/StateContext';

import { deslogar } from '../../services/FiltrosApi/LoginToken';

//--------------------------------------
export function ApiUsuario() {
    const { state, dispatch } = useContext(Context);
    const { logado } = state.cliente;

    function Redirecionar() {
        alert("erro na API")
        deslogar();
        window.location.reload();
    }

    async function LogUsuario(token) {
        await api.get(`/usuario/infologado/${token}`)
            .then(res => {
                const dd = res.data[0];
                dispatch({
                    type: 'set_logado',
                    payload: {
                        ...logado,
                        idLogado: dd._id,
                        nome: dd.nome,
                        cpf: dd.cpf,
                        email: dd.email,
                        nivel: dd.nivel,
                        conectado: true
                    }
                });
            }).catch(() => Redirecionar())
    };
    return { LogUsuario }
};
